module.exports = __webpack_public_path__ + "static/media/countdown-organizer-logos.3d13a318.png";